<ca-header
  loadProducts
  applicationTitle="Menu de produtos"
  [accessToken]="accessToken"
  (logoutEvent)="logout($event)"
  (headerEvent)="response($event)"
  [ApplicationLinks]="ApplicationLinks"
></ca-header>

@if (!isTouring) {
  <ca-search
    (searchResponse)="renderResponse($event)"
  ></ca-search>

  <ca-notification
    [ApplicationLinks]="ApplicationLinks"
  ></ca-notification>    
}

@if (myCards && !isTouring) {
  <app-button-serasa-alerta
    [myProduct]="myCards"
  ></app-button-serasa-alerta>
}

@if (!isTouring) {
  <ca-card-list-view
    class="main"
    (cardListViewEvent)="response($event)"
    [(cards)]="myCards"
  ></ca-card-list-view>
}

@defer {
  <app-tour [isTouring]="isTouring"></app-tour>
}

<ca-footer>
  <p>
    ©currentYear Experian Information Solutions, Inc. Experian Marketing
    Services, all rights reserved
  </p>
  <p>
    Experian and the Experian marks used herein are service marks or
    registered trademarks of Experian Informations Solutions, Inc
  </p>
  <p>
    Other product and company names mentioned herein are the property of their
    respective owners.
  </p>
</ca-footer>

<ngx-guided-tour
  skipText="Pular tour"
  nextText="Próximo"
  backText="Anterior"
  doneText="Ok, entendi!"
  closeText="Fechar"
  minimalTourStepWidth="457"
  tourStepWidth="457"
  progressIndicatorLocation="top-of-tour-block"
  [progressIndicator]="progressIndicator"
  >
</ngx-guided-tour>

<ng-template #progressIndicator>
  {{ tourService?.currentTourStepDisplay }} de
  {{ tourService?.currentTourStepCount }}
</ng-template>
